// extracted by mini-css-extract-plugin
export var lbContainerOuter = "t_s6";
export var lbContainerInner = "t_s7";
export var movingForwards = "t_s8";
export var movingForwardsOther = "t_s9";
export var movingBackwards = "t_tb";
export var movingBackwardsOther = "t_tc";
export var lbImage = "t_td";
export var lbOtherImage = "t_tf";
export var prevButton = "t_tg";
export var nextButton = "t_th";
export var closing = "t_tj";
export var appear = "t_tk";